import { ProjectHealthStyled } from './project-health.styles';
import ProjectFinancials from './project-financials/project-financials';
import ProjectMaterials from './project-materials/project-materials';

const ProjectHealthNew = ({ isGroupView, materialsData, companyData }) => {
  const hasValidMaterials =
    Array.isArray(materialsData) &&
    materialsData.some((material) => material.description && material.description.trim() !== '');

  return (
    <ProjectHealthStyled>
      <div className="card">
        <ProjectFinancials isGroupView={isGroupView} companyData={companyData} />
      </div>

      {!isGroupView && hasValidMaterials && (
        <div className="card margin-top">
          <ProjectMaterials materialsData={materialsData} />
        </div>
      )}
    </ProjectHealthStyled>
  );
};

export default ProjectHealthNew;
